// pdfjs 6 lit le global `Iterator` au niveau module, absent avant Chrome 122 / Safari 18.4.
if (typeof (globalThis as any).Iterator !== "function") {
  const iteratorPrototype = Object.getPrototypeOf(Object.getPrototypeOf([][Symbol.iterator]()));
  const IteratorShim = function () {} as unknown as { prototype: unknown };
  IteratorShim.prototype = iteratorPrototype;
  (globalThis as any).Iterator = IteratorShim;
}
